<template>
    <div v-if="isLoggedIn" class="container page">

        <section v-if="displayPart==10" class="card card-default">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-8"><h5>Santam Shared Services Award</h5></div>
                    <div class="col-sm-4">   
                    </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="nomMessage">
                    <b-card no-body>
                        <b-tabs pills vertical lazy card no-nav-style nav-wrapper-class="col-12 col-md-4" content-class="col-12 col-md-8">
                            <b-tab>
                                <template v-slot:title>
                                    <div class="text-center"><b-img thumbnail fluid :src="require('../assets/image/santamsharedservices.jpg')" alt=""></b-img></div>
                                    <div class="mb-1 text-center ceo">Philile Mkhize</div>
                                </template>
                                <b-card-text class="text-left">
                                    <p>Dear colleagues,</p>
                                    <p>Recognition starts with noticing the difference someone makes and taking the time to say, "Your contribution matters." When we celebrate one another, we strengthen our sense of belonging and reinforce the behaviours that help us succeed together.</p>
                                    <p>Our <b>Pace Setters Recognition Programme</b> celebrates colleagues who bring out the best in Shared Services through agility and excellence, accountability, caring leadership, collaboration, exceptional service, and practical innovation. It also recognises the everyday contributions of those who consistently support others, uphold our values, and make a positive impact.</p>
                                    <p>I encourage you to <b>nominate a colleague or team who has gone above and beyond in demonstrating these qualities</b>. Consider those who have simplified a process, worked collaboratively to solve a challenge, enhanced a customer or colleague experience, or made a meaningful difference through their actions. When submitting your nomination, please provide a specific example of what they did and the impact it had.</p>
                                    <p>Let's ensure that great contributions do not go unnoticed.</p>
                                    <p>Thank you for taking the time to recognise and celebrate one another, and for the role you play in making Shared Services a great place to work.</p>
                                    <p><b>Kind Regards</b></p>
                                    <p><b>Philile Mkhize</b></p>
                                    <p><b>GROUP CHIEF OPERATING OFFICER: SHARED SERVICES</b></p>
                                    <!--<p>Group Executive: Shared Services</p>-->
                                </b-card-text>
                            </b-tab>




                            <hr />
                            <div class="text-right mt-3 mb-3">
                                <div v-if="isAwardRunning">
                                    <a class="btn btn-primary" href="#" @click.prevent="showNomForm()" v-b-tooltip.hover.left title="Create a new Award nomination">New Award Nomination</a>
                                </div>
                                <div v-else class="alert alert-secondary" role="alert">Nominations are now closed</div>
                            </div>
                        </b-tabs>
                    </b-card>
                </div>
            </div>
        </section>


        <template v-if="displayPart==0">
            <div class="row mb-2">
                <div class="col-sm-8">
                    <h5>Santam Shared Services Award</h5>
                    Select an Award below, then complete your nomination.
                </div>
                <div class="col-sm-4 text-right">
                    <a href="#" @click.prevent="displayPart=10" class="btn btn-secondary">Back</a>
                </div>
            </div>
            <!--
    { value: '', text: '--- Please select an option ---' },
    { value: 'Individual', text: 'Individual' },
    { value: 'Team', text: 'Team' },
    { value: 'Discipline and Purpose', text: 'Discipline and Purpose' },
    { value: 'Client Centric Award', text: 'Client Centric Award < 35' },
    { value: 'General employee', text: 'General employee (non-management)' },
        -->
            <section class="card mb-4 nomAwardCategory3">
                

                <b-tabs v-model="tabIndex" lazy card nav-class="selcatNav">
                    <b-tab title="Agility and Excellence" @click="awardCatSelected('Agility and Excellence')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Agility and Excellence</h3>
                            <hr />
                            <p>Recognises an individual or team who respond quickly to change, remove complexity and deliver outcomes at speed, while maintaining high standards.</p>
                            <ul>
                                <li>Simplifying processes while improving quality</li>
                                <li>Responding decisively to changing business needs</li>
                                <li>Delivering outcomes faster without burnout</li>
                            </ul>

                        </b-card-text>
                    </b-tab>
                    <b-tab title="Discipline and Purpose" @click="awardCatSelected('Discipline and Purpose')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Discipline and Purpose</h3>
                            <hr />
                            <p>Celebrates an individual or team who demonstrates strong ownership, attention to detail and accountability, executing reliably and delivering outcomes that stand the test of quality.</p>
                            <ul>
                                <li>Clear planning and disciplined execution</li>
                                <li>Strong follow-through and accountability</li>
                                <li>Doing the right thing, even when it’s difficult</li>
                            </ul>

                        </b-card-text>
                    </b-tab>
                    <b-tab title="Leadership Excellence" @click="awardCatSelected('Leadership Excellence')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Leadership Excellence</h3>
                            <hr />
                            <p>Recognises a leader who plays a pivotal role in shaping their team’s growth and development, and who builds trust through openness, empathy and partnership.</p>
                            <ul>
                                <li>Constructive, honest engagement with stakeholders</li>
                                <li>Shared ownership of outcomes</li>
                                <li>Psychological safety and trust in action</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="One Shared Services" @click="awardCatSelected('One Shared Services')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>One Shared Services</h3>
                            <hr />
                            <p>Recognises individuals or teams who break silos and contribute to a more integrated, future-fit Shared Services model that builds solutions for business problems.</p>
                            <ul>
                                <li>Cross-functional collaboration</li>
                                <li>Simplifying and standardising processes</li>
                                <li>Using data, automation or AI to work smarter</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Santam Experience Champion" @click="awardCatSelected('Santam Experience Champion')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Santam Experience Champion</h3>
                            <hr />
                            <p>Recognises exceptional service that improves the experience of employees, internal stakeholders, brokers or clients.</p>
                            <ul>
                                <li>Acts on stakeholder or client needs with care</li>
                                <li>Resolves a complex issue or prevents service failure</li>
                                <li>Creates a consistently positive and trusted experience</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Innovation in Motion" @click="awardCatSelected('Innovation in Motion')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Innovation in Motion</h3>
                            <hr />
                            <p>Recognises an individual or team who drives meaningful innovation, transforming ideas into practical solutions that enhance the way Shared Services operates and delivers value.</p>
                            <ul>
                                <li>Applies technology, automation, AI or new thinking responsibly</li>
                                <li>Improves a service, process or employee experience</li>
                                <li>Turns an idea into a solution that can be sustained or scaled</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                    <b-tab title="Everyday Pace Setter" @click="awardCatSelected('Everyday Pace Setter')">
                        <b-card-text class="text-left">
                            <div class="mb-3"><sitecode-image src="santamsharedservicesheader.png" class="w-100" /></div>

                            <h3>Everyday Pace Setter</h3>
                            <hr />
                            <p>Recognising a dependable colleague whose daily actions, attitude and contribution consistently make Shared Services better.</p>
                            <ul>
                                <li>Regularly goes beyond what was expected</li>
                                <li>Supports colleagues and strengthens the team environment</li>
                                <li>Models the Santam values through everyday actions</li>
                            </ul>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </section>

            <section class="card card-default mt-3" v-if="fNomination.form.awardCat !== null">
                <div class="card-header">
                    <h5>Nomination for: <b class="darkShade">{{ fNomination.form.awardCat }}</b></h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6"><strong>Nominee{{isNomSingleOnly ? "" : "s"}}:</strong></div>
                        <div class="col-sm-6 text-right"></div>
                    </div>
                    <div v-for="r in selectedNominees" :key="r._rowNum" class="row">
                        <template v-if="r.isEntireDivision">
                            <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                            <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                        </template>
                        <template v-else>
                            <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                            <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                            <div class="col">{{ r.division }}</div>
                        </template>
                    </div>
                    <div v-if="selectedNominees.length===0" class="text-danger">Please select nominee{{isNomSingleOnly ? "" : "s"}}.</div>
                    <div class="mt-1">
                        <b-button type="button" pill @click="$bvModal.show('modalChooseNominees')" variant="primary" size="sm">{{selectedNominees.length===0 ? 'Select' : 'Update'}}  Nominee{{isNomSingleOnly ? "" : "s"}}</b-button>
                        <!--<a href="#" @click.prevent="$bvModal.show('modalChooseNominees')">Select Nominees</a>-->
                    </div>

                    <hr />
                    <b-form @submit.prevent="onSubmitAward" novalidate>
                        <!--
        <b-form-group id="groupAwardCat" label-for="selectAwardCat" label="Award Category:" :invalid-feedback="fNomination.errors.awardCat" description="">
            <b-form-select id="selectAwardCat" v-model="fNomination.form.awardCat" :options="awardCatList" value-field="value" text-field="text" :state="fNomination.state.awardCat" />
        </b-form-group>
           -->
                        <b-form-group id="groupMotivation" label-for="txtMotivation" label="Motivation:" :invalid-feedback="fNomination.errors.motivation" :description="1500-fNomination.form.motivation.length + ' characters remaining'">
                            <b-form-textarea id="txtMotivation" v-model="fNomination.form.motivation" :state="fNomination.state.motivation" placeholder="Provide a short motivation" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupaction" label-for="txtaction" label="Actions Taken:" :invalid-feedback="fNomination.errors.action" :description="1500-fNomination.form.action.length + ' characters remaining'">
                            <b-form-textarea id="txtaction" v-model="fNomination.form.action" :state="fNomination.state.action" placeholder="Describe action taken" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <b-form-group id="groupimpact" label-for="txtImpact" label="Impact:" :invalid-feedback="fNomination.errors.impact" :description="1500-fNomination.form.impact.length + ' characters remaining'">
                            <b-form-textarea id="txtImpact" v-model="fNomination.form.impact" :state="fNomination.state.impact" placeholder="Impact thereof" rows="3" max-rows="5" maxlength="1500" />
                        </b-form-group>

                        <hr />
                        <!--<div class="row">
                            <div class="col-sm-6"><strong>Endorser for your nomination:</strong></div>
                            <div class="col-sm-6 text-right"></div>
                        </div>
                        <div v-for="r in selectedNominators" :key="r._rowNum" class="row">
                            <template v-if="r.isEntireDivision">
                                <div class="col-1 text-right"><b-icon icon="collection" style="color:#9f34a0"></b-icon></div>
                                <div class="col" style="color:#9f34a0">Entire division: {{ r.division }}</div>
                            </template>
                            <template v-else>
                                <div class="col-1 text-right"><b-icon icon="person" style="color:#ccc"></b-icon></div>
                                <div class="col">{{ r.firstname + ' ' + r.surname }}</div>
                                <div class="col">{{ r.division }}</div>
                            </template>
                        </div>
                        <div v-if="selectedNominators.length!==2" class="text-danger">Select an endorser to support your nomination (Optional).</div>
                        <div class="mt-1"><b-button type="button" pill @click="$bvModal.show('modalChooseNominators')" variant="primary" size="sm">{{selectedNominators.length===0 ? 'Select' : 'Update'}} Endorser</b-button></div>
                        <hr />-->

                        <div class="text-right"><b-button type="submit" variant="primary">Submit</b-button></div>
                    </b-form>
                </div>
            </section>
        </template>

        <section v-if="displayPart==1" class="card card-default">
            <div class="card-header">
                <h5>Santam Shared Services Award</h5>
            </div>
            <div class="card-body">
                <b-alert variant="success" show>
                    <h4 class="alert-heading">Santam Shared Services Award Nomination</h4>
                    <p>Successfully submitted the Santam Shared Services Award Nomination.</p>
                    <p>Your reference for this nomination is: <b>{{awardId}}</b></p>
                </b-alert>

                <b-button type="button" pill @click="displayPart=10" variant="primary">Ok</b-button>

            </div>
        </section>



        <!--
    **************************************************************************************************************************************************
                                                                M O D A L S
    **************************************************************************************************************************************************
    -->
        <!-- Modal - Nominees -->
       <b-modal id="modalChooseNominees" :title="'NOMINEE' + (isNomSingleOnly ? '' : 'S')" hide-footer size="xl" no-close-on-backdrop>
            <member-select :title="'Select Nominee' + (isNomSingleOnly ? '' : 's') + ' for the ' + fNomination.form.awardCat"
                           :selectedTitle="isNomSingleOnly ? 'Selected nominee' : 'Selected nominees'"
                           :isCountryFixed="true"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="'stm_3938'"
                           :selectedMems="selectedNominees"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           memberType="santam-shared-services"
                           :isSingle ="isNomSingleOnly"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominees')">Done</b-button></div>
        </b-modal>

        <!-- Modal - Nominators -->
        <b-modal id="modalChooseNominators" title="NOMINATORS" hide-footer size="xl" no-close-on-backdrop>
            <member-select title="Select an endorser to support your nomination"
                           selectedTitle="Selected endorser to support your nomination"
                           :defaultCountryCode="memberClusterCode"
                           :defaultDivisionCode="memberDivisionCode"
                           :selectedMems="selectedNominators"
                           :isAllowWholeDivision="false"
                           :showContinue="false"
                           :isSingle="true"
                           class="mb-3" />
            <hr />
            <div class="text-right"><b-button type="submit" variant="primary" @click="$bvModal.hide('modalChooseNominators')">Done</b-button></div>
        </b-modal>


    </div>

</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from '@/components/HelloWorld.vue'
    import SitecodeImage from '@/components/SitecodeImage';
    import axios from 'axios'
    //import sjData from '@/sjUtilData'
    import MemberSelect from '@/components/MemberSelect';
	//import ContentDb from '@/components/ContentDb';



    export default {
        name: 'SanlamAward',
        components: { MemberSelect, SitecodeImage },//, ContentDb },
        data() {
            return {
                isAwardRunning: true, //when false, nominations are closed


                displayPart: 10,

                fNomination: { 
					form: { awardCat: '', motivation: '', action: '', impact: '' }
                },
                tabIndex: 0,

                selectedNominees: [],
                selectedNominators: [],

                roles: { ca: false, cc: false, idea: false, inv: false },

                reportTitle: '',
                currentIdeaRowNum: null,
                modalPart: 0,

                awardCatList: [
                    { value: '', text: '--- Please select an option ---' },
                    { value: 'Agility and Excellence', text: 'Agility and Excellence' },
                    { value: 'Discipline and Purpose', text: 'Discipline and Purpose' },
                    { value: 'Leadership Excellence', text: 'Leadership Excellence' }, //individual
                    { value: 'One Shared Services', text: 'One Shared Services' },
                    { value: 'Santam Experience Champion', text: 'Santam Experience Champion' },//individual
                    { value: 'Innovation in Motion', text: 'Innovation in Motion' },
                    { value: 'Everyday Pace Setter', text: 'Everyday Pace Setter' },//individual
                ],

                awardId: 0

            }
        },
        computed: {
            isLoggedIn() {
				return this.$store.state.isLoggedIn && this.memberDivisionCode != 'ra_7090' //Disable SanPay division from access
            },
            countryList() {
                if (this.isCountryFixed) { //only show the default cluster.
                    return this.$store.state.countryList.filter(country => country.countryCode === this.defaultCountryCode);
                } else {
                    return [{ countryCode: null, country: '-- Please select a Cluster--', disabled: true }]
                        .concat(this.$store.state.countryList);
                }
            },
            memberClusterCode() {
                return this.$store.state.memberStore.member.clusterCode
            },
            memberDivisionCode() {
                return this.$store.state.memberStore.member.divisionCode
            },
            currentIdea() {
                if (this.currentIdeaRowNum === null) return null;
                return this.ideas[this.currentIdeaRowNum];
            },
            isNomSingleOnly() {
                //return false; //Allow multiple nominees for all award categories.

                switch (this.fNomination.form.awardCat) {
                    case "Leadership Excellence":
                    case "Santam Experience Champion":
                    case "Everyday Pace Setter":
                        return true; //single
                    default:
                        return false; //team
                }

                //return false;// !this.fNomination.form.awardCat.startsWith("Innovation Award");

                //return this.fNomination.form.awardCat == 'Leadership with Excellence'
                //    || this.fNomination.form.awardCat == 'Rising Star'
                //    || this.fNomination.form.awardCat == 'Everyday Hero';
            },
        },
        created() {
            //formSetState must be called on creation, to ensure all fields are setup
            this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm

            this.$store
                .dispatch('getDivisionList', {})
                .then(() => {
                    this.displayPart = 10;

                })
                .catch((error) => {
                    this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error)));
                });


        },
        mounted() {

        },
        methods: {
            showNomForm() {
                this.formSetState(this.fNomination, true, true) //formObj, resetState, resetForm
                this.displayPart = 0;
                this.$nextTick(() => {
                    this.tabIndex = 0; //Select first tab
                    this.awardCatSelected('Agility and Excellence'); //ensure got awardCat for first tab
                });
            },

            msgBox(msg, title) {
                this.$bvModal.msgBoxOk(msg, { title: typeof title === 'undefined' ? 'Please note:' : title, centered: true })
            },

            //*** formStatusUpdate - used to display form errors.
            //Ensure this.form contains the list of fields.
            //Call  formStatusUpdate(true) to initialise/clear the form errors.
            //formObject is the object that contains the following objects:  .form, .formState, .formErrors
            formSetState(formObj, resetState, resetForm) {
                if (typeof resetState === 'undefined') resetState = false;
                if (typeof resetForm === 'undefined') resetForm = false;
                if (typeof formObj.init === 'undefined') formObj.init = { ...formObj.form }; //Initialise .formInit object to be a copy of .form object.
                if (typeof formObj.errors === 'undefined') this.$set(formObj, 'errors', {}); //use this.$set  to make errors object reactive
                if (typeof formObj.state === 'undefined') this.$set(formObj, 'state', {});   //use this.$set  to make state object reactive

                if (resetState || resetForm) {
                    if (resetForm) formObj.form = { ...formObj.init }; //copy .init to .form

                    formObj.errors = {}; //reset formErrors object
                    formObj.state = {};
                }

                //update formState
                var fields = Object.getOwnPropertyNames(formObj.form);
                for (let i = 0; i < fields.length; i++) {
                    let field = fields[i];
                    if (resetState) {
                        formObj.state[field] = null;
                    } else if (typeof formObj.errors[field] === 'undefined' || formObj.errors[field] === '') {
                        formObj.state[field] = true;
                    } else {
                        formObj.state[field] = false;
                    }
                }
            },

            awardCatSelected(awardCat) {
                let awardCats = this.awardCatList.map(e => { return e.value; });

                if (!awardCats.includes(awardCat)) {
                    this.msgBox('Cannot find "' + awardCat + '" in [' + awardCats.join(', ') + ']!');
                    return;
                }

                this.fNomination.form.awardCat = awardCat;
                this.selectedNominees = [];
                //this.tabSelected = true;
            },

            onSubmitAward() {
                try {

                    this.formSetState(this.fNomination, true);//formObj, resetState, resetForm
                    this.fNomination.form.nominees = this.selectedNominees.map(item => item.isEntireDivision ? 'div:' + item.entireDivisionCode : item.memberId);
                    let nominators = this.selectedNominators.filter(item => !item.isEntireDivision);
                    if (this.selectedNominees.length === 0) {
                        this.msgBox('Please select at least one nominee.', 'Nominees are required');
                        return;
                    }
                    //if (nominators.length !== 2) {
                    //    this.msgBox('Please select two seconders to support your nomination.', 'Two seconders are required');
                    //    return;
                    //}

                    
                    var payload = { ...this.fNomination.form, awardType: "santam-shared-services" }
                    if (nominators.length !== 0) {
                        payload.endorserMemberId = nominators[0].memberId;
                    }

                    return axios
                        .post(
                            '/api/SanlamAward/newnomination',
                            payload
                        )
                        .then(({ data }) => {
                            console.log(data);

                            const er = data.errorMessage;
                            this.awardId = data.awardId;

                            if (data.awardId == 0) {
                                this.msgBox('An unexpected error occured: ' + er)
                            } else {
                                this.displayPart = 1;
                                //this.msgBox('Successfully submitted nomination');
                            }
                        })
                        .catch((error) => {
                            this.msgBox(error.response.data.message ? error.response.data.message : ('An error has occured: ' + JSON.stringify(error.response.data)));
                            if (error.response.data.formErrors) {
                                this.fNomination.errors = error.response.data.formErrors;
                                this.formSetState(this.fNomination);
                            }
                        })
                        ;
                } catch (err) {
                    this.msgBox(err.message, 'An unexpected error occured submitting the nomination');
                }
            },

        }




    }
</script>
